import React, { startTransition, useContext, useEffect, useState } from 'react'
import style from './Inspector.module.scss'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import { Wellcome } from '../../components/Wellcome'
import { Btn } from '../../c_ui/Btn'
import { getTranslation, Language } from '../../language'
import { AddAndDeleteOption } from '../../components/AddAndDeleteOption'
import autorizationAnalizer from '../../service/functions/autorizationAnalizer'
import { CartOption } from '../../components/CartOption'
import { TgCart } from '../../c_ui/TgCart'
import { FilesOption } from '../../components/FilesOption'
import { Onion } from '../../c_ui/Onion'
import { OnionOption } from '../../components/OnionOption'

const BASE_URL = process.env.REACT_APP_BASE_URL

const roles = {
	ad: 'ad',
	files: 'files',
	tg: 'tg',
	onion: 'onion',
}

export const Inspector = () => {
	const lang = useContext(Language)
	const TEXT = getTranslation(lang)
	const navigate = useNavigate()
	const [userName, setUserName] = useState('')
	const [isActive, setIsActive] = useState('')

	useEffect(() => {
		document.body.style.overflow = ''
	}, [])

	useEffect(() => {
		async function fetchData() {
			const storedUserId = sessionStorage.getItem('id')

			try {
				const user = await axios.post(`${BASE_URL}/getUserById`, {
					userId: storedUserId,
				})

				if (user) {
					setUserName(user.data.name)
				}
			} catch (err) {
				console.log('fetchData func error')
				startTransition(() => {
					navigate('/')
				})
			}
		}

		fetchData()
	}, [])

	const checkAutorization = () => {
		const autorizationData = autorizationAnalizer()
		if (!autorizationData) {
			startTransition(() => {
				navigate('/')
			})
		}
	}

	const handlerAddAndDelete = () => {
		checkAutorization()
		setIsActive(roles.ad)
	}

	const handlerFiles = () => {
		checkAutorization()
		setIsActive(roles.files)
	}

	const handlerCart = () => {
		checkAutorization()
		setIsActive(roles.tg)
	}
	const handlerOnion = () => {
		checkAutorization()
		setIsActive(roles.onion)
		// navigate('/')
	}

	return (
		<div className={style.inspector}>
			<Wellcome userName={userName} />

			<div className={style.buttons}>
				<Btn
					text={'+ / -'}
					handle={handlerAddAndDelete}
					isActive={isActive === roles.ad}
				/>
				<Btn
					text={TEXT.inspector_btn_files}
					handle={handlerFiles}
					isActive={isActive === roles.files}
				/>
				<Btn
					text={<TgCart />}
					handle={handlerCart}
					isActive={isActive === roles.tg}
				/>
				<Btn
					text={<Onion />}
					handle={handlerOnion}
					isActive={isActive === roles.onion}
				/>
			</div>

			{isActive === roles.ad && <AddAndDeleteOption userName={userName} />}
			{isActive === roles.files && <FilesOption />}
			{isActive === roles.tg && <CartOption />}
			{isActive === roles.onion && <OnionOption />}

			{!isActive && <p className={style.choice}>{TEXT.choice}</p>}
		</div>
	)
}
